import './App.css';
import logo from "./assets/logo.png"
import { IoLogoTiktok } from "react-icons/io5";
import { FaFacebookSquare } from "react-icons/fa";
import { FaInstagramSquare } from "react-icons/fa";
import { SiGooglemaps } from "react-icons/si";
import { FaPhoneAlt } from "react-icons/fa";

function App() {
  const socialmedia=[
    { id: 4, name: "Contact us on Al Ghubra (Next to Ship Mall)", icon: <FaPhoneAlt size={28} />, link: "https://wa.me/96894443641" },

    {id:3,name:"location:Al Ghubra",icon:<SiGooglemaps size={28}/>,link:"https://share.google/Fb6NrIKn4No4aLqTI"},
  { id: 5, name: "Contact us on Al Maabela 7 (Next to United Finance)", icon: <FaPhoneAlt size={28} />, link: "https://wa.me/96897090960" },
      {id:3,name:"location:Al Maabela 7",icon:<SiGooglemaps size={28}/>,link:"https://share.google/E1PyIGfIWUS8UYt3Y"},

  { id: 6, name: "Contact us on Al Maabela (Front of Muscat Mall)", icon: <FaPhoneAlt size={28} />, link: "https://wa.me/96897090890" }, 
        {id:3,name:"location:Al Maabela",icon:<SiGooglemaps size={28}/>,link:"https://maps.app.goo.gl/AE3PPLMfN6uJHna9A?g_st=awb"},

      {id:2,name:"Contact us on instgram",icon:<FaInstagramSquare size={28}/>,link:"https://www.instagram.com/premiumpharmacy_?igsh=MXQ4Z2J0bzV1NHI0Zg%3D%3D"},

      {id:0,name:"Contact us on TikTok",icon:<IoLogoTiktok size={28}/>,link:"https://www.tiktok.com/@premium.pharmacy3?_r=1&_t=ZS-988epA1DoTI"},

    {id:1,name:"Contact us on facebook",icon:<FaFacebookSquare size={28}/>,link:"https://www.facebook.com/profile.php?id=61583268757160#"},
 ]
  return (
    <div className="App">
<img src={logo}className='logo'alt='logo'/>
<div className='content'>
  {socialmedia.map((item)=>{
    return(
      <div className='container'>
<a href={item?.link} target='_blank'>
          <div>
          {item?.icon}
          </div>
      <p className='name'> {item?.name}</p>

</a>
      </div>
    )
  })}
</div>
    </div>
  );
}

export default App;
